import { animated, config, useTransition } from '@react-spring/web';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { useMountedState } from 'react-use';

export const Revealer = ({
  front,
  back,
  revealed,
  imediate = false,
  className,
  onRest,
}: {
  front: ReactNode;
  back: ReactNode;
  revealed: boolean;
  imediate?: boolean;
  className?: string;
  onRest?: () => void;
}) => {
  const [initialized, setInitialized] = useState(false);
  const isMounted = useMountedState();

  const transitions = useTransition(revealed, {
    imediate,
    initial: null,
    from: { opacity: initialized ? 0 : 1, y: initialized ? -200 : 0 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: -200 },
    reverse: revealed,
    exitBeforeEnter: true,
    config: config.stiff,
    onRest: () => {
      if (isMounted()) {
        setInitialized(true);
      }
      onRest?.();
    },
  });
  return (
    <div className={className}>
      {transitions((styles, isRevealed) => (
        <animated.div style={styles}>{isRevealed ? front : back}</animated.div>
      ))}
    </div>
  );
};
